<template>
  <div data-testid="page-visitor-profiles">
    <template v-if="hasCompany">
      <VisitorProfilesSection />
    </template>

    <AlertBox v-else type="warning" class="mt-6">
      {{ $t('PartnerCompany.noPartnerCompany') }}
    </AlertBox>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import VisitorProfilesSection from '@/components/VisitorProfiles/VisitorProfilesSection.vue'
import type { MeQuery } from '@/gql/myomr'
import { useRoleRedirect } from '@/services/roleRedirect'

useRoleRedirect('viewVisitorProfiles')

const props = defineProps<{
  me: NonNullable<MeQuery['me']>
}>()

const hasCompany = computed(() => !!props.me?.partnerCompany)
</script>
